import { render, staticRenderFns } from "./ReserveSOTable.vue?vue&type=template&id=47d47528&scoped=true"
import script from "./ReserveSOTable.vue?vue&type=script&lang=js"
export * from "./ReserveSOTable.vue?vue&type=script&lang=js"
import style0 from "./ReserveSOTable.vue?vue&type=style&index=0&id=47d47528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d47528",
  null
  
)

export default component.exports